<template>
  <div v-if="isLoaded">
    <div class="content-body">
      <b-modal
        id="modal_form"
        ref="modal_form"
        :title="modal_titulo"
        :ok-title="modal_botao"
        close-title="Fechar"
        cancel-title="Cancelar"
        :ok-disabled="form.errors.any()"
        v-model="showModal"
        @ok="handleOk"
      >
        <form
          @submit.stop.prevent="handleOk"
          @keydown="form.errors.clear($event.target.name)"
        >
          <label>UF Origem</label>
          <multiselect
            v-model="ufOriSelected"
            :options="optionsListItemUf"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Pressione enter para selecionar"
            select-label="Pressione enter para selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('uf_id_ori')"
            v-if="form.errors.has('uf_id_ori')"
          ></b-form-feedback>

          <label>UF Destino</label>
          <multiselect
            v-model="ufDesSelected"
            :options="optionsListItemUf"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Pressione enter para selecionar"
            select-label="Pressione enter para selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('uf_id_des')"
            v-if="form.errors.has('uf_id_des')"
          ></b-form-feedback>

          <label>Status</label>
          <b-form-group>
            <b-form-radio-group
              v-model="form.status"
              :options="optionsLivStatus"
              name="status"
              stacked
              plain
            ></b-form-radio-group>
          </b-form-group>
          <b-form-feedback
            v-text="form.errors.get('status')"
            v-if="form.errors.has('status')"
          ></b-form-feedback>
        </form>
        <div slot="modal-footer" class="w-100">
          <div class="float-left">
            <spinner v-if="loading" message="Processando..."></spinner>
          </div>
          <div class="float-right">
            <b-btn @click="showModal = false" variant="secondary">
              Fechar
            </b-btn>
            <b-btn
              @click="handleOk($event)"
              variant="primary"
              :disabled="isDisabled"
            >
              Enviar
            </b-btn>
          </div>
        </div>
      </b-modal>

      <b-modal
        id="modal_form_uf"
        ref="modal_form_uf"
        :title="modal_titulo"
        :ok-title="modal_botao"
        close-title="Fechar"
        cancel-title="Cancelar"
        :ok-disabled="form_uf_ordem.errors.any()"
        v-model="showModalUfOrdem"
        @ok="handleOkPercursoUf"
      >
        <form
          @submit.stop.prevent="handleOkPercursoUf"
          @keydown="form.errors.clear($event.target.name)"
        >
          <label>Ordem</label>
          <b-form-input
            type="text"
            placeholder="Ordem"
            v-model="form_uf_ordem.ordem"
            name="ordem"
          >
          </b-form-input>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('ordem')"
            v-if="form.errors.has('ordem')"
          ></b-form-feedback>

          <label>UF</label>
          <multiselect
            v-model="ufOrdemSelected"
            :options="optionsListItemUf"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Selecione"
            tag-placeholder="Pressione enter para selecionar"
            select-label="Pressione enter para selecionar"
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <b-form-feedback
            class="text-danger"
            v-text="form.errors.get('uf_id')"
            v-if="form.errors.has('uf_id')"
          ></b-form-feedback>

          <div v-if="this.modal_acao == 'u'">
            <label>Status</label>
            <b-form-group>
              <b-form-radio-group
                v-model="form_uf_ordem.status"
                :options="optionsLivStatusUfOrdem"
                name="status"
                stacked
                plain
              ></b-form-radio-group>
            </b-form-group>
            <b-form-feedback
              v-text="form_uf_ordem.errors.get('status')"
              v-if="form_uf_ordem.errors.has('status')"
            ></b-form-feedback>
          </div>
        </form>
        <div slot="modal-footer" class="w-100">
          <div class="float-left">
            <spinner v-if="loading" message="Processando..."></spinner>
          </div>
          <div class="float-right">
            <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
            <b-btn @click="showModalUfOrdem = false" variant="secondary">
              Fechar
            </b-btn>
            <b-btn
              @click="handleOkPercursoUf($event)"
              variant="secondary"
              :disabled="isDisabled"
            >
              Enviar
            </b-btn>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import AvisoErros from "../components/AvisoErros";

export default {
  components: {
    AvisoErros,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalUfOrdem: false,
      isFullscreen: false,
      ufOrdemSelected: [],
      ufOriSelected: [],
      ufDesSelected: [],
      optionsLivStatus: [],
      optionsLivStatusUfOrdem: [],
      optionsListItemUf: [],
      errors_array: [],
      form: new Form({
        peruf_id: "",
        uf_id_ori: "",
        uf_id_des: "",
        status: "",
      }),
      form_uf_ordem: new Form({
        peruford_id: "",
        peruf_id: "",
        ordem: "",
        status: "",
        uf_id: "",
      }),
      helpForm: new Form({ statusRecord: [], params: [] }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "uf_ori.cd",
          title: "UF Origem",
        },
        {
          name: "uf_des.cd",
          title: "UF Destino",
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status",
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  watch: {
    ufOriSelected(obj) {
      this.form.uf_id_ori = obj.value;
    },
    ufDesSelected(obj) {
      this.form.uf_id_des = obj.value;
    },
  },
  mounted() {
    this.getLivGeral();
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      }else {
        this.onUpdate(this.form.peruf_id);
      }
    },
    handleOkPercursoUf(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStorePercursoUfOrdem();
      } else {
        this.onUpdatePercursoUfOrdem(this.form_uf_ordem.peruford_id);
      }
    },
    onCreate() {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.ufOriSelected = "";
      this.ufDesSelected = "";
      this.errors_array = "";
      this.errors_array = [];
      this.form.status = 1;
      this.$refs.modal_form.show();
    },
    onCreatePercursoUfOrdem(data) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form_uf_ordem.reset();
      this.form_uf_ordem.status = 1;
      this.form_uf_ordem.peruf_id = data.peruf_id;
      this.$refs.modal_form_uf.show();
    },
    onEdit(data) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.item = [];
      this.errors_array = [];
      this.ufOriSelected = [];
      this.ufDesSelected = [];
      this.helpForm.reset();
      this.form.peruf_id = data.peruf_id;
      this.ufOriSelected = {label: data.uf_ori.nome, value: data.uf_ori.uf_id};
      this.ufDesSelected = {label: data.uf_des.nome, value: data.uf_des.uf_id};
      this.form.status = data.status.valor;
      this.$refs.modal_form.show();
    },
    onEditPercursoUfOrdem(data) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form_uf_ordem.reset();
      this.errors_array = "";
      this.errors_array = [];
      this.form_uf_ordem.peruford_id = data.peruford_id;
      this.ufOrdemSelected = { label: data.uf.nome, value: data.uf.uf_id };
      this.form_uf_ordem.uf_id = data.uf.uf_id;
      this.form_uf_ordem.ordem = data.ordem;
      this.form_uf_ordem.status = data.status.valor;
      this.$refs.modal_form_uf.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form.uf_id_ori = this.ufOriSelected.value;
      this.form.uf_id_des = this.ufDesSelected.value;
      this.form
        .post("/api/percursouf/store")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .patch("/api/percursouf/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onStorePercursoUfOrdem() {
      this.loading = true;
      this.isDisabled = true;
      this.form_uf_ordem.uf_id = this.ufOrdemSelected.value;
      this.form_uf_ordem
        .post("/api/percursouf/ordem/store")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onUpdatePercursoUfOrdem(id) {
      this.loading = true;
      this.isDisabled = true;
      this.form_uf_ordem.peruford_id = id;
      this.form_uf_ordem
        .patch("/api/percursouf/ordem/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/" + this.rota + "/status")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    getLivGeral() {
      this.helpForm
        .get("/api/percursouf/jsonlistgeral")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.status_percurso_uf.forEach((obj) => {
            this.optionsLivStatus.push({ text: obj.descr, value: obj.valor });
          });
          response.status_percurso_uf_ordem.forEach((obj) => {
            this.optionsLivStatusUfOrdem.push({
              text: obj.descr,
              value: obj.valor,
            });
          });
          response.uf.forEach((obj) => {
            this.optionsListItemUf.push({ label: obj.nome, value: obj.uf_id });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
